"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.bind");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireWildcard(require("react"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _jsxFileName = "/Users/newuser/Documents/GitHub/wordsby-components/src/components/img.js";

var Wimg =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2["default"])(Wimg, _Component);

  function Wimg(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.img = _react["default"].createRef();
    _this.imageLoaded = _this.imageLoaded.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      imgAspect: false
    };
    return _this;
  }

  var _proto = Wimg.prototype;

  _proto.imageLoaded = function imageLoaded() {
    var width = this.img.naturalWidth;
    var height = this.img.naturalHeight;
    this.setState({
      imgAspect: height / width * 100 + "%"
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        field = _this$props.field,
        sizes = _this$props.sizes,
        props = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["field", "sizes"]);

    if (!field) {
      return null;
    }

    var file;

    if (!!field.localFile) {
      file = field.localFile;
    } else {
      file = field;
    }

    var useStringUrl = typeof field === "string";
    var useNestedStringUrl = !!field.url && typeof field.url === "string";

    if (useStringUrl || useNestedStringUrl) {
      var stringUrl = useStringUrl ? field : field.url;
      var srcset = "";

      if (sizes) {
        // build srcset
        var _arr = Object.keys(sizes);

        for (var _i = 0; _i < _arr.length; _i++) {
          var key = _arr[_i];

          if (key.includes("height")) {
            continue;
          } else if (key.includes("width")) {
            srcset += sizes[key] + "w, ";
          } else {
            srcset += sizes[key] + " ";
          }
        } // remove trailing comma


        srcset = srcset.replace(/,\s*$/, ""); // set string url to medium url

        stringUrl = sizes.medium;
      }

      return _react["default"].createElement("div", {
        className: "gatsby-image-wrapper",
        style: {
          position: "relative",
          overflow: "hidden"
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62
        },
        __self: this
      }, _react["default"].createElement("div", {
        style: {
          width: "100%",
          paddingBottom: this.state.imgAspect
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66
        },
        __self: this
      }), _react["default"].createElement("img", (0, _extends2["default"])({
        ref: function ref(n) {
          return _this2.img = n;
        },
        onLoad: this.imageLoaded,
        style: {
          position: "absolute",
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center center",
          fontFamily: "\"object-fit: cover; object-position: 50% 50%\"",
          opacity: 1,
          transition: "opacity 0.5s ease 0s"
        },
        src: stringUrl,
        srcSet: srcset
      }, props, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72
        },
        __self: this
      })));
    } else if (!!file && file.childImageSharp) {
      if (file.childImageSharp.fluid) {
        return _react["default"].createElement(_gatsbyImage["default"], (0, _extends2["default"])({
          fluid: file.childImageSharp.fluid,
          imgStyle: {
            objectFit: "cover",
            objectPosition: "50% 50%",
            fontFamily: "\"object-fit: cover; object-position: 50% 50%\""
          }
        }, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 96
          },
          __self: this
        }));
      } else if (file.childImageSharp.fixed) {
        return _react["default"].createElement(_gatsbyImage["default"], (0, _extends2["default"])({
          fixed: file.childImageSharp.fixed
        }, props, {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 107
          },
          __self: this
        }));
      }
    } else {
      console.warn("Wordsby Image requires a src url or a field containing a valid childImageSharp query");
      return null;
    }
  };

  return Wimg;
}(_react.Component);

var _default = Wimg;
exports["default"] = _default;